<template>
  <div class="home_page order_detail" v-loading="dataLoading">
    <!-- 状态轴 -->
    <div class="status">
      <StateAxis :statusList="statusList" :currentIndex="currentIndex">
        <template slot-scope="scope">
          <div class="status_top">{{scope.row.name}}</div>
          <div>{{scope.row.time}}</div>
        </template>
      </StateAxis>
    </div>
    <!-- 状态 -->
    <div class="order_status">
      <i class="el-icon-info"></i>
      当前订单状态：{{$getDictLabel('MAIN_ORDER_STATUS' ,orderInfo.orderStatus)}}
    </div>
    <div class="order_label">
      <i class="el-icon-collection-tag"></i>
      商品信息
    </div>
    <el-table
      :data="orderGoodList"
      style="width: 100%">
      <el-table-column
        label="商品信息"
        header-align="center"
        min-width="200px"
        prop="skuCode">
        <template slot-scope="scope">
          <div class="good">
            <div class="good_img">
              <img :src="scope.row.fileUrls || defaultImg"
                   alt=""
                   class="cursor-pointer"
                   width="83px"
                   height="83px"
                   @click="goodDetailHandle(scope.row)" />
            </div>
            <div class="good_info">
              <div class="good_name multi_line_overflow cursor-pointer"
                   @click="goodDetailHandle(scope.row)">{{scope.row.commodityName}}</div>
              <div class="good_code multi_line_overflow">{{scope.row.skuCode}}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="产品型号"
        min-width="200px"
        align="center"
        prop="commodityModel">
      </el-table-column>
      <el-table-column
        label="单价(元)"
        align="center"
        prop="commodityPrice">
      </el-table-column>
      <el-table-column
        label="数量"
        align="center"
        prop="commodityNum">
      </el-table-column>
      <el-table-column
        label="运费(元)"
        align="center"
        prop="expressFee">
      </el-table-column>
      <el-table-column
        label="小计(元)"
        align="center"
        prop="commodityTotalPrice">
      </el-table-column>
    </el-table>
    <el-row class="order_price">
      <el-col :span="19">&nbsp;</el-col>
      <el-col :span="2" class="align-right">订单总金额：</el-col>
      <el-col :span="3">￥{{orderInfo.orderMoney}}</el-col>
      <el-col :span="19">&nbsp;</el-col>
      <el-col :span="2" class="align-right">运费：</el-col>
      <el-col :span="3">￥{{orderInfo.expressFee}}</el-col>
    </el-row>
    <div class="order_money">
      合计：<font class="total_money">￥{{totalMoney}}</font>
    </div>
    <div class="order_label">
      <i class="el-icon-collection-tag"></i>
      配送地址
    </div>
    <el-table
      :data="addressList"
      border
      style="width: 100%;">
      <el-table-column
        label="收货人"
        align="center"
        width="200px"
        prop="receiveGoodsPerson">
      </el-table-column>
      <el-table-column
        label="收货电话"
        align="center"
        width="150"
        prop="receiveGoodsPhone">
      </el-table-column>
      <el-table-column
        label="收货地址"
        align="center"
        prop="province">
        <template slot-scope="scope">
          {{scope.row.province}},{{scope.row.city}},{{scope.row.area}},{{scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column
        label="客户名称"
        align="center"
        prop="companyName">
      </el-table-column>
      <el-table-column
        label="订单备注"
        align="center"
        prop="remarks">
      </el-table-column>
    </el-table>
    <div class="order_label flex-sp" v-if="waybillList.length">
      <div>
        <i class="el-icon-collection-tag"></i>
        配送信息
      </div>
      <span class="waybill_info">共计{{orderInfo.packages}}个包裹&nbsp; {{orderInfo.deliveryCommodityCount}}件商品</span>
    </div>
    <!-- 发运单 -->
    <div class="waybill" v-if="waybillList.length">
      <el-table
        :data="item.commodityList"
        v-for="(item, index) in waybillList"
        :key="index"
        style="width: 100%;margin-bottom: 20px">
        <el-table-column
          label="发货商品"
          header-align="center">
          <template slot-scope="scope">
            <div class="good">
              <div class="good_img">
                <img :src="scope.row.goodsFile || defaultImg"
                     alt=""
                     class="cursor-pointer"
                     width="60px"
                     height="60px"
                     @click="goodDetailHandle(scope.row)">
              </div>
              <div class="good_info">
                <div class="good_name multi_line_overflow cursor-pointer"
                     @click="goodDetailHandle(scope.row)">{{scope.row.goodsName}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="商品编号"
          align="center"
          prop="skuCode">
        </el-table-column>
        <el-table-column
          label="发货数量"
          align="center"
          prop="goodsNum">
        </el-table-column>
        <el-table-column
          label="发货日期"
          align="center">
          <template>
            {{item.deliveryDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="配送详情"
          align="center">
          <template>
            <el-button type="text" @click="logisticsHandle(index)">查看配送轨迹</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="order_label">
      <i class="el-icon-collection-tag"></i>
      发票信息
    </div>
    <el-table
      :data="invoiceList"
      border
      style="width: 100%">
      <el-table-column
        label="发票类型"
        align="center"
        width="100px"
        prop="invoiceType">
        <template slot-scope="scope">
          {{scope.row.invoiceType ===  '10' ? '普通发票' : '专用发票'}}
        </template>
      </el-table-column>
      <el-table-column
        label="发票抬头"
        align="center"
        prop="companyName">
      </el-table-column>
      <el-table-column
        label="税务登记证号"
        align="center"
        width="160px"
        prop="taxpayerIdentity">
      </el-table-column>
      <el-table-column
        label="基本开户账号"
        align="center"
        width="170px"
        prop="bankAccountNo">
      </el-table-column>
      <el-table-column
        label="开户行"
        align="center"
        prop="openingBank">
      </el-table-column>
      <el-table-column
        label="注册场所地址"
        align="center"
        prop="companyAddress">
      </el-table-column>
      <el-table-column
        label="注册电话"
        align="center"
        width="120px"
        prop="companyPhone">
      </el-table-column>
    </el-table>
    <!-- 发运单物流详情 -->
    <el-dialog :visible.sync="logisticsVisible" width="50%" :modal="false" title="物流轨迹" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-row class="logistics">
          <el-col :span="7">物流公司：{{logisticsInfo.logisticsCompany}}</el-col>
          <el-col :span="7">运单号：{{logisticsInfo.logisticsNumber}}</el-col>
        </el-row>
        <el-table
          :data="logisticsInfo.list"
          :show-header="false"
          style="width: 100%">
          <el-table-column
            prop="operatedate"
            width="180px">
          </el-table-column>
          <el-table-column
            prop="eventcode"
            width="100px">
            <template slot-scope="scope">
              {{scope.row.eventcode === 'END_POD' ? '已签收' : ''}}
            </template>
          </el-table-column>
          <el-table-column
            prop="eventdescription">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import StateAxis from '@/components/state-axis'
export default {
  name: 'punchoutOrderDetail', // punchout订单详情
  components: {
    StateAxis
  },
  data () {
    return {
      statusList: [{
        name: '审核中',
        time: '',
        key: '8'
      }, {
        name: '已下单',
        time: '',
        key: '11'
      }, {
        name: '平台发货',
        time: '',
        key: '15'
      }, {
        name: '确认收货',
        time: '',
        key: '19'
      }],
      dataLoading: false,
      orderInfo: {},
      defaultImg: require('@/assets/img/bitmap.png'),
      logisticsVisible: false, // 物流信息弹窗
      logisticsIndex: -1 // 显示发货单的索引
    }
  },
  computed: {
    orderId () {
      return this.$route.query.id
    },
    // 当前时间轴状态
    currentIndex () {
      let currentIndex = -1
      if (this.orderInfo.orderStatus) {
        currentIndex = this.statusList.findIndex(item => {
          return item.key === this.orderInfo.orderStatus
        })
      }
      return currentIndex
    },
    // 订单整体商品列表
    orderGoodList () {
      let list = []
      if (this.orderInfo.commodityDetails) {
        list = this.orderInfo.commodityDetails || []
      }
      return list
    },
    // 订单地址
    addressList () {
      let list = []
      if (this.orderInfo.payOrderAddressVo) {
        list = [{
          ...this.orderInfo.payOrderAddressVo,
          remarks: this.orderInfo.remarks,
          companyName: this.orderInfo.companyName
        }]
      }
      return list
    },
    // 发运单列表
    waybillList () {
      let list = []
      if (this.orderInfo.deliveryCommodityList) {
        list = this.orderInfo.deliveryCommodityList || []
      }
      return list
    },
    invoiceList () {
      let list = []
      if (this.orderInfo.payOrderInvoiceVo) {
        list = [this.orderInfo.payOrderInvoiceVo]
      }
      return list
    },
    // 物流信息弹窗数据
    logisticsInfo () {
      let info = {
        logisticsCompany: '', // 物流公司
        logisticsNumber: '', // 物流单号
        list: [] // 物流信息
      }
      if (this.logisticsIndex !== -1 && this.waybillList.length) {
        let row = this.waybillList[this.logisticsIndex]
        info.logisticsCompany = row.logisticsCompany
        info.logisticsNumber = row.logisticsNumber
        info.list = row.deliveryList || []
      }
      return info
    },
    totalMoney () {
      let money = 0
      if (this.orderInfo) {
        money = (Number(this.orderInfo.orderMoney) || 0) + (Number(this.orderInfo.expressFee) || 0)
      }
      return money.toFixed(2)
    }
  },
  created () {

  },
  mounted () {
    this.getInfo()
  },
  methods: {
    // 获取订单详情
    getInfo () {
      if (!this.orderId) {
        return false
      }
      this.dataLoading = true
      this.$http.get(`/openapi/punchoutOrder/orderInfoById/${this.orderId}`)
        .then(({ data }) => {
          if (data.resultCode !== '0') {
            this.orderInfo = {}
            return false
          }
          this.orderInfo = data.result
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 显示发货单物流
    logisticsHandle (index) {
      this.logisticsIndex = index
      this.logisticsVisible = true
    },
    // 跳转商品详情
    goodDetailHandle (row) {
      this.$router.push({
        name: 'punchoutGoodsDetail',
        query: {
          skuId: row.skuId,
          spuId: row.spuId
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.order_detail{
  padding: 35px;
  background: #fff;
  .status{
    padding: 20px 100px;
    .status_top{
      margin-top: 10px;
    }
  }
  .order_status{
    padding-left: 30px;
    line-height: 80px;
    font-size: 16px;
    color: #F04844;
    border: 1px solid #ebebeb;
    background: #F5F7FA;
  }
  .order_label{
    line-height: 60px;
    font-size: 16px;
    // padding: 0 20px;
    margin-left: 10px;
     margin-top: 20px;
    // background: url();
    // .waybill_info{
    //   // font-size: 12px;
    // }
  }
  .good{
    display: flex;
    .good_img{
      padding-right: 10px;
      flex-shrink: 0;
    }
    .good_info{
      flex-shrink: 1;
      flex-grow: 1;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      // .good_name{}
      .good_code{
        -webkit-line-clamp: 1;
      }
    }
  }
  .waybill{
    .good{
      display: flex;
      .good_img{
        padding-right: 10px;
        flex-shrink: 0;
      }
    }
  }
  .order_price{
    line-height: 30px;
  }
  .order_money{
    text-align: right;
    padding-right: 50px;
    background: rgba(242, 242, 242, 1);
    line-height: 40px;
    border: 1px solid #eee;
    .total_money{
      color: #F04844;
      font-weight: bold;
    }
  }
  .logistics{
    margin: 0 50px;
    border-bottom: 1px solid #eee;
    margin-bottom: 50px;
  }
}
</style>
